import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Archive, Clock, Rocket, TrendingDown} from "lucide-react";
import {useHistory} from "react-router-dom";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const CommentSortSheet = styled(({className, community, uuid, onClose}) => {

    const makeLink = (commentSort) =>
        community
            ? `/c/${community}/p/${uuid}?commentSort=${commentSort}`
            : `/p/${uuid}?commentSort=${commentSort}`;

    const history = useHistory();
    const handleSort = (selectedSort) => {
        history.replace(makeLink(selectedSort));
        onClose();
    }

    return (
        <div className={className}>
            <MenuItem onClick={() => handleSort('')}>
                <MenuItemIcon>
                    <Rocket size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Top
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={() => handleSort('new')}>
                <MenuItemIcon>
                    <Clock size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Newest
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={() => handleSort('old')}>
                <MenuItemIcon>
                    <Archive size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Oldest
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={() => handleSort('controversial')}>
                <MenuItemIcon>
                    <TrendingDown size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Worst
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default CommentSortSheet;
